var _defs, _path, _rect, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9, _path0, _path1;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgIco7(_ref, svgRef) {
  let title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    "data-name": "Layer 1",
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 123 123",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, ".cls-1{fill:#fff;}.cls-2{fill:#013177;}.cls-3{fill:#074ea3;}.cls-4{fill:#33c3ef;}.cls-5{fill:#00a4e3;}"))), _path || (_path = /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M107.43,60.91l-.26-.3A32.14,32.14,0,0,0,83.09,49.75a1.18,1.18,0,0,0-1.17,1.16l-.3,23.44H18a1.17,1.17,0,0,0-1.17,1.17v9.56A1.17,1.17,0,0,0,18,86.26h92.44a1.18,1.18,0,0,0,1.18-1.18V71.93A16.61,16.61,0,0,0,107.43,60.91Z"
  })), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    className: "cls-2",
    x: 11.4,
    y: 27.58,
    width: 66.84,
    height: 49.2,
    rx: 9.22
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M102.28,86.65a7.21,7.21,0,1,1-7.21-7.21A7.21,7.21,0,0,1,102.28,86.65Z"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M95.07,95.42a8.78,8.78,0,1,1,8.77-8.77A8.78,8.78,0,0,1,95.07,95.42Zm0-14.41a5.64,5.64,0,1,0,5.64,5.64A5.65,5.65,0,0,0,95.07,81Z"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    className: "cls-3",
    d: "M69,27.72H20.76a9.1,9.1,0,0,0-9.2,9V53.65H78.24V36.71A9.11,9.11,0,0,0,69,27.72Z"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    className: "cls-4",
    d: "M66.44,52.62l-15-12.91a1.56,1.56,0,0,0-2.59,1.19V47H24.22a1.56,1.56,0,0,0-1.57,1.56v9.79a1.57,1.57,0,0,0,1.57,1.57H48.81V66a1.58,1.58,0,0,0,.89,1.42,1.64,1.64,0,0,0,.68.15,1.55,1.55,0,0,0,1-.35L66.41,55A1.57,1.57,0,0,0,67,53.83,1.52,1.52,0,0,0,66.44,52.62Z"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M111.05,67.7a16.68,16.68,0,0,0-3.62-6.79l-.26-.3a32,32,0,0,0-15.43-9.67,1.17,1.17,0,0,0-1.49,1.13V68a1.18,1.18,0,0,0,1.18,1.18h18.48a1.17,1.17,0,0,0,1.14-1.48Z"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M31.14,77.87a8.78,8.78,0,1,0,8.78,8.78A8.78,8.78,0,0,0,31.14,77.87Z"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M95.07,77.87a8.78,8.78,0,1,0,8.77,8.78A8.79,8.79,0,0,0,95.07,77.87Z"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    className: "cls-5",
    d: "M22.65,53.43v4.89a1.57,1.57,0,0,0,1.57,1.57H48.81V66a1.58,1.58,0,0,0,.89,1.42,1.64,1.64,0,0,0,.68.15,1.55,1.55,0,0,0,1-.35L66.41,55A1.57,1.57,0,0,0,67,53.83a1.75,1.75,0,0,0,0-.4Z"
  })), _path0 || (_path0 = /*#__PURE__*/React.createElement("path", {
    className: "cls-3",
    d: "M31.14,80.45a6.2,6.2,0,1,0,6.2,6.2A6.21,6.21,0,0,0,31.14,80.45Z"
  })), _path1 || (_path1 = /*#__PURE__*/React.createElement("path", {
    className: "cls-3",
    d: "M95.07,80.45a6.2,6.2,0,1,0,6.2,6.2A6.21,6.21,0,0,0,95.07,80.45Z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIco7);
export default __webpack_public_path__ + "static/media/ico-7.888d113ab4edfc7342dcbc3849a72479.svg";
export { ForwardRef as ReactComponent };